
<div class="column-index">
  <div class="index-container">
    <div v-if="isLoading" class="d-flex justify-content-center align-items-center py-4 h-100">
      <v-progress-circular color="primary" indeterminate></v-progress-circular>
    </div>

    <template v-else>
      <div class="d-flex">
        <h4 class="ma-0" style="font-size: 16px;"><b>Rearrange column</b> <span class="badge badge-primary ml-1"
            style="line-height: inherit;">{{ selectedColumns.length }}</span></h4>
      </div>
      <div class="mt-1">
        <p class="ma-0" :class="{ 'line-clamp': !expanded }">The order of the column list, from top to bottom, matches
          the left-to-right order in the report preview. Adjust the order by dragging the cards up or down, then click
          the update button below to save your changes.</p>
      </div>
      <div class="d-flex justify-content-center align-items-center">
        <v-divider color="#D7D7D7" />
        <div class="d-flex justify-content-center align-items-center ml-2" @click="expanded = !expanded"
          style="cursor: pointer;">
          {{ expanded ? 'less' : 'more' }}
          <v-icon small color="#3F3F3F" class="ml-1">{{ expanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
        </div>
      </div>
      <div style="overflow: auto;">
        <draggable v-model="selectedColumns" group="column-index" @start="drag = true" @end="updateColumnPositions"
          handle=".column-drag-handle" class="d-flex flex-column list-group" ghost-class="moving-class"
          style="gap: 8px;">
          <transition-group type="transition" name="flip-list">
            <div v-for="(column, index) in selectedColumns" :key="index" class="column-item list-group-item">
              <v-icon small class="column-drag-handle" style="cursor: grab;">mdi-drag-vertical</v-icon>
              <div v-if="column.group === 'Questionnaire::Template'" class="d-flex flex-column ml-2">
                <b>#{{ column.columnName }} {{ column.header_name }}</b>
                <div v-for="(item, index) in column.data" :key="index" class="d-flex flex-column ml-2"
                  style="gap: 4px;">
                  <b style="font-size: 12px;">{{ item.header_name }}</b>
                  <i style="color: #848484; font-size: 12px;">{{ item.original_header_name }}</i>
                </div>
              </div>
              <div v-else class="d-flex flex-column ml-2">
                <b>{{ column.header_name }}</b>
                <i style="color: #848484; font-size: 12px;">{{ column.original_header_name }}</i>
              </div>
            </div>
          </transition-group>
        </draggable>
      </div>
    </template>
  </div>
</div>

